<div class="definition-list">
  <div class="field">
    <label class="field-label">Entity Type</label>
    <div class="field-content entity-type">
      {{sp_select_tag "" dataBehaviour="entity-type-select" choices=entityItems selected=entityType required=true includeBlank=false}}
    </div>
  </div>

  <div class="field">
    <label class="field-label">Category</label>
    <div class="field-content category-id">
      {{sp_select_tag "" dataBehaviour="category-id-select" searchable=true}}
    </div>
  </div>
</div>
